/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Faq_Agents_TermInputs */

const en_marketing_faq_agents_term = /** @type {(inputs: Marketing_Faq_Agents_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it work with AI coding agents?`)
};

const es_marketing_faq_agents_term = /** @type {(inputs: Marketing_Faq_Agents_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Funciona con agentes de programación con IA?`)
};

const fr_marketing_faq_agents_term = /** @type {(inputs: Marketing_Faq_Agents_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est-ce que ça marche avec les agents de code IA ?`)
};

/**
* | output |
* | --- |
* | "Does it work with AI coding agents?" |
*
* @param {Marketing_Faq_Agents_TermInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_faq_agents_term = /** @type {((inputs?: Marketing_Faq_Agents_TermInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Faq_Agents_TermInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_faq_agents_term(inputs)
	if (locale === "es") return es_marketing_faq_agents_term(inputs)
	return fr_marketing_faq_agents_term(inputs)
});